import styled from "styled-components";
import { Button } from "@mui/material";

export const Container = styled.div``;

interface ILinkButtonProps {
	selected: boolean;
}

export const AreaButton = styled.div`
	position: relative;
`;

export const CloseButton = styled.div`
	position: absolute;
	bottom: 0;
	left: -20px;
`;

export const LinkButton = styled(Button)<ILinkButtonProps>`
	&&& {
		text-transform: none;
		color: #000;
		padding: 0;
		margin: 0;
		min-width: fit-content;

		> span {
			font-size: 14px;
			line-height: 1;
			font-weight: ${({ selected }) => (selected ? "bold" : "normal")};
			text-align: left;
		}

		&:hover {
			> span {
				text-decoration: underline;
			}
		}
	}
`;

export const AreaSubCategory = styled.div`
	display: flex;
	flex-direction: column;
	align-content: flex-start;
	align-items: flex-start;
	gap: 0.4rem;
	padding: 0.4rem 0 0 1rem;
`;
